import { confirm, length, regexp, required } from 'js/utils/Validation/validationRules';

export const password = [
    required({ error: 'playtech.mobile.system.user.tooltip.password.required' }),
    length({ min: 8, max: 20, error: 'playtech.mobile.system.user.tooltip.password.length' }),
    regexp({
        re: /^[A-Za-z0-9.@_#$'&+()*`;!?,-/]+$/,
        error: 'playtech.mobile.system.user.tooltip.password.regexp'
    })
];

export const passwordVerify = (field = 'newPassword') => [
    confirm({
        field,
        error: 'playtech.mobile.system.user.tooltip.passwordVerify.required'
    })
];
